import React from 'react';
import { Grid } from '@mui/material';

import { ModuleSearchField, SelectField, SimpleTextField, useSettings } from 'app/main/components';
import { type DetailsSectionInfoContentProps } from 'app/main/components/page-layouts';

export default function WebsitesDetailsSectionInfo(
	props: DetailsSectionInfoContentProps & { disableIdentityAssociation?: boolean }
) {
	const { t } = useSettings('websites');

	const [table, setTable] = React.useState(props.model.website_table);
	const [tableItem, setTableItem] = React.useState<string | null>(
		props.model.webs_table_uid || props.model.peop_uid || props.model.comp_uid || props.model.user_uid
	);

	function handleTableChange(name, value) {
		setTable(value);
		setTableItem(null);
		props.sendChange(name, value);
	}

	function handleTableItemChange(name, value) {
		setTableItem(value);
		props.sendChange(name, value);
	}

	return (
		<>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* WEBSITE */}
				<SimpleTextField
					name="webs_title"
					label={t('DETAILS_WEBSITES_FIELD_TITLE')}
					value={props.model.webs_title}
					isEdit
					sendChange={props.sendChange}
					required
					validationError={t('ERROR_TEXT_EMAIL')}
				/>
			</Grid>
			<Grid size={{ sm: 6, xs: 12 }}>
				{/* DESCRIPTION */}
				<SimpleTextField
					name="webs_description"
					label={t('DETAILS_WEBSITES_FIELD_DESCRIPTION')}
					value={props.model.webs_description}
					isEdit
					sendChange={props.sendChange}
				/>
			</Grid>
			{!props.disableIdentityAssociation && (
				<>
					<Grid size={{ sm: 4, xs: 12 }}>
						{/* WEBSITE SOURCE TABLE */}
						<SelectField
							name="webs_table"
							label={t('CONTACTS_LINKED_TABLE')}
							options={[
								{ value: 'companies', title: t('MODULE_COMPANIES_NAME') }
								// { value: 'people', title: t('MODULE_PEOPLE_NAME') },
								// { value: 'users', title: t('MODULE_USERS_NAME') }
							]}
							value={table}
							isEdit
							sendChange={handleTableChange}
						/>
					</Grid>
					<Grid size={{ sm: 8, xs: 12 }}>
						{/* WEBSITE SOURCE ITEM */}
						{table ? (
							<ModuleSearchField
								name="webs_table_uid"
								label={t(`MODULE_${table}_NAME`)}
								module={table}
								uid={tableItem}
								isEdit
								sendChange={handleTableItemChange}
								required
								validationError={t('ERROR_TEXT_REQUIRED')}
							/>
						) : (
							<></>
						)}
					</Grid>
				</>
			)}
		</>
	);
}
